import { render, staticRenderFns } from "./HeaderButtonC.vue?vue&type=template&id=4513719b&"
import script from "./HeaderButtonC.vue?vue&type=script&lang=js&"
export * from "./HeaderButtonC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports